import { MouseEvent, SyntheticEvent } from 'react';

import { useParams } from 'react-router-dom';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';

import useIsMultipleTeamsEnabled from '@/hooks/useIsMultipleTeamsEnabled';
import { useIsOrgAdmin } from '@/hooks/useIsOrgAdmin';
import { BasetenPageEnum, calcSwitchPath, usePageSwitcher } from '@/routes';
import { preventDefault, samePageLinkNavigation } from '@/sections/Workspace/utils';

import { MatchParams, Tabs } from '../types';
import { Container } from './styled';

const mapTabsToTabTitles: Record<Tabs, string> = {
  [Tabs.General]: 'General',
  [Tabs.Members]: 'Members',
  [Tabs.Billing]: 'Billing and usage',
  [Tabs.Activity]: 'Activity',
  [Tabs.ApiKeys]: 'API keys',
  [Tabs.Environments]: 'Environments',
  [Tabs.Secrets]: 'Secrets',
};

function Header() {
  const goToPage = usePageSwitcher();
  const { tabId } = useParams<MatchParams>();
  const isOrgAdmin = useIsOrgAdmin();
  const isMultipleTeamsEnabled = useIsMultipleTeamsEnabled();

  const activeTabId = tabId || Tabs.General;

  function getTabParams(tabId: Tabs) {
    return {
      tabId,
    };
  }

  function getResolvedUrl(tabId: Tabs) {
    return calcSwitchPath(BasetenPageEnum.Settings, false, getTabParams(tabId), {});
  }

  function handleTabChange(ev: SyntheticEvent, newTabId: Tabs) {
    if (
      ev.type !== 'click' ||
      (ev.type === 'click' && samePageLinkNavigation(ev as MouseEvent<HTMLAnchorElement>))
    ) {
      goToPage(BasetenPageEnum.Settings, getTabParams(newTabId));
    }
  }

  return (
    <TabContext value={activeTabId}>
      <Container sx={{ pl: 4 }}>
        <TabList onChange={handleTabChange}>
          {Object.values(Tabs)
            .filter((tab) => isOrgAdmin || ![Tabs.Billing, Tabs.Activity].includes(tab))
            .filter(
              (tab) => !isMultipleTeamsEnabled || ![Tabs.Secrets, Tabs.Environments].includes(tab),
            )
            .map((tab) => (
              <Tab
                key={tab}
                onClick={preventDefault}
                href={getResolvedUrl(tab as Tabs)}
                label={mapTabsToTabTitles[tab as Tabs]}
                value={tab}
              />
            ))}
        </TabList>
      </Container>
    </TabContext>
  );
}

export default Header;
